import { useMutation } from '@tanstack/react-query';
import { Lookbook } from '@typings';
import { useTranslation } from 'react-i18next';

import { addToast } from '../../../components/various/Toasts';
import { createAccountRequest } from '../../lookbookRepository';

interface Payload {
  lookbookId: string;
  data: Lookbook.CreateAccountRequestDTO;
}

export const useCreateAccountRequest = () => {
  const { t } = useTranslation(['accounts']);

  return useMutation({
    mutationFn: async ({ data, lookbookId }: Payload) => createAccountRequest(lookbookId, data),
    onError: () => {
      addToast(t('accounts:account_request_creation_fail'), { type: 'error' });
    },
    onSuccess: () => {
      addToast(t('accounts:account_request_creation_success'));
    },
  });
};
